module.exports = __webpack_public_path__ + "img/word.e3e183f3.png";